<wsd-extended-card
  [loading]="!(interactions$ | async)"
  [expanded]="(interactions$ | async)?.content?.length ? expanded : null"
  (sizeChanged)="sizeChanged.emit()"
  [redirectTo]="['/organizations', organizationId, 'modify', 'interactions']"
  [title]="'DATA_PORTAL.INTERACTIONS.TITLE' | translate">

  <div *ngIf="interactions$ | async as data">
    <div class="ui-g m-b-10" *ngFor="let interaction of data.content">
      <div class="ui-g-12 ellipses m-b-5">
        <i *ngIf="interaction.important" class="fa fa-exclamation primary-color m-r-5"></i>
        <i *ngIf="interaction.confidential" class="fa fa-eye-slash primary-color m-r-5"></i>
        <a (click)="detail = interaction">{{ interaction.subject }}</a>
      </div>
      <div class="ui-g-12 subtext">
        <i class="fa fa-calendar"></i> {{ interaction.date | date: 'dd/MM/yyyy' }} - {{ interaction.person }}
      </div>
    </div>

    <div *ngIf="!data.content.length" class="text-center">
      {{ 'DATA_PORTAL.INTERACTIONS.EMPTY' | translate }}
    </div>
  </div>
</wsd-extended-card>

<wsd-interaction-dialog
  [interaction]="detail"
  (closed)="detail = null">
</wsd-interaction-dialog>
